import { useEffect, useState } from "react";
import { MapPinned, Download } from "lucide-react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function PfsMapSettings() {
  const [info, setInfo] = useState({ url: "", count: 0, imported_at: "", error: "" });
  const [url, setUrl] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/settings/pfs-map").then((r) => { setInfo(r.data); setUrl(r.data.url); }).catch(() => {}); }, []);

  const doImport = async () => {
    setBusy(true);
    try { const { data } = await api.post("/settings/pfs-map/import", { url }); setInfo(data); toast.success(`Importati ${data.count} PFS`); }
    catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };

  return (
    <div className="rounded-xl border border-border bg-card p-6" data-testid="pfs-map-settings">
      <div className="mb-1 flex items-center gap-2"><MapPinned size={18} className="text-primary" /><h3 className="font-bold text-navy">Mappa armadi PFS</h3></div>
      <p className="mb-4 text-sm text-muted-foreground">Link della mappa Google My Maps con gli armadi PFS. Il tecnico vede "Naviga al PFS" quando il PFS della pratica (es. NA_01/16e13) è presente nella mappa. Aggiornamento automatico ogni notte.</p>
      <div className="flex flex-wrap items-end gap-2">
        <div className="min-w-[320px] flex-1 space-y-1.5"><Label>Link mappa</Label><Input value={url} onChange={(e) => setUrl(e.target.value)} placeholder="https://maps.app.goo.gl/…" data-testid="pfs-map-url" /></div>
        <Button onClick={doImport} disabled={busy || !url} data-testid="pfs-map-import"><Download size={16} />{busy ? "Importo…" : "Importa / aggiorna"}</Button>
      </div>
      <p className="mt-3 text-xs text-muted-foreground" data-testid="pfs-map-status">
        {info.count ? `${info.count} PFS in mappa · ultimo aggiornamento ${new Date(info.imported_at).toLocaleString("it-IT")}` : "Nessuna mappa importata"}
        {info.error ? <span className="text-destructive"> · Ultimo aggiornamento automatico non riuscito: {info.error}</span> : null}
      </p>
    </div>
  );
}
